<template>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-tooltip bottom>
      <v-btn slot="activator" icon flat small @click="goPresentacion" :disabled="disableGoToPresentation">
        <v-icon color="primary">keyboard_arrow_right</v-icon>
      </v-btn>
      <span v-if="!this.item.canEdit">No puede ver esta presentación</span>
      <span v-else-if="!item.canView && item.canEdit && !$store.getters.isSafRole">La presentación está siendo corregida por LPF</span>
      <span v-else>Ver presentación</span>
    </v-tooltip>
  </v-card-actions>
</template>

<script>
export default {
  props: {
    item: Object
  },

  computed: {
    clubCanEdit () {
      return this.item.canView && this.item.canEdit
    },
    safCanEdit () {
      return this.item.canEdit
    },
    disableGoToPresentation () {
      return !this.safCanEdit || !this.clubCanEdit
    }
  },

  methods: {
    goPresentacion () {
      this.$router.push({ name: 'presentacion', params: { id: this.item.pk } })
    }
  }
}
</script>
